module.exports = __webpack_public_path__ + "img/key-feature-2.b1ce11a9.svg";